/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateClassResponse } from './CreateClassResponse';
import {
    CreateClassResponseFromJSON,
    CreateClassResponseFromJSONTyped,
    CreateClassResponseToJSON,
    CreateClassResponseToJSONTyped,
} from './CreateClassResponse';

/**
 * 
 * @export
 * @interface ResultOfCreateClassResponse
 */
export interface ResultOfCreateClassResponse {
    /**
     * 
     * @type {CreateClassResponse}
     * @memberof ResultOfCreateClassResponse
     */
    data: CreateClassResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfCreateClassResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfCreateClassResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfCreateClassResponse interface.
 */
export function instanceOfResultOfCreateClassResponse(value: object): value is ResultOfCreateClassResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfCreateClassResponseFromJSON(json: any): ResultOfCreateClassResponse {
    return ResultOfCreateClassResponseFromJSONTyped(json, false);
}

export function ResultOfCreateClassResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfCreateClassResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CreateClassResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfCreateClassResponseToJSON(json: any): ResultOfCreateClassResponse {
    return ResultOfCreateClassResponseToJSONTyped(json, false);
}

export function ResultOfCreateClassResponseToJSONTyped(value?: ResultOfCreateClassResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateClassResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

